import store from '../../store'
import router from '../../router'
import dialogs from '../common/dialogs'
import forms from '../common/forms'
import vIndividualSelector from './IndividualSelector'
import vPeopleLoader from './PeopleLoader'
import vContactForm from './ContactForm'
import vHolderList from './HolderList'
import docPassportRF from './DocPassportRF.js'
import docTemporaryIdRF from './DocTemporaryIdRF.js'
import docBirthCertRF from './DocBirthCertRF.js'
import docPensionCertRF from './DocPensionCertRF.js'
import docDriverLicRF from './DocDriverLicRF.js'
import docMarriageCertRF from './DocMarriageCertRF.js'
import individual from './Individual.js'
import contact from './Contact.js'
import client from '../client/index.js'
import formats from '../../api/formats'

export default {
  registeredTypeDoc () {
    return [
      'PASSPORT_RF',
      'TEMPORARY_ID_RF',
      'BIRTH_CERT_RF',
      'PENSION_CERT_RF',
      'DRIVER_LIC_RF',
      'MARRIAGE_CERT_RF'
    ]
  },
  createStrategy (cxt, type) {
    switch (type) {
      case 'PASSPORT_RF': {
        return docPassportRF.createStrategy(cxt)
      }
      case 'TEMPORARY_ID_RF': {
        return docTemporaryIdRF.createStrategy(cxt)
      }
      case 'BIRTH_CERT_RF': {
        return docBirthCertRF.createStrategy(cxt)
      }
      case 'PENSION_CERT_RF': {
        return docPensionCertRF.createStrategy(cxt)
      }
      case 'DRIVER_LIC_RF': {
        return docDriverLicRF.createStrategy(cxt)
      }
      case 'MARRIAGE_CERT_RF': {
        return docMarriageCertRF.createStrategy(cxt)
      }
      case 'INDIVIDUAL': {
        return individual.createStrategy(cxt)
      }
      case 'CONTACT': {
        return contact.createStrategy(cxt)
      }

      // default: {
      //   return docPassportRF.createStrategy(cxt)
      // }
    }
  },
  newForm () {
    return new Promise((resolve, reject) => {
      dialogs.register('v-contact-form', vContactForm)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-contact-form
        v-on:close="$emit('close')"
        v-on:change="onChange"
        :fullscreen="fullscreen"></v-contact-form>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data)
          }
        }}
      dialogs.modal(comp)
    })
  },
  loadForm () {
    return new Promise((resolve, reject) => {
      dialogs.register('v-people-loader', vPeopleLoader)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-people-loader
        v-on:close="$emit('close')"
        v-on:change="onChange"
        :fullscreen="fullscreen"></v-people-loader>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data)
          }
        }}
      dialogs.modal(comp)
    })
  },
  open (itemId, newWindow) {
    let url = this.getItemRef(itemId)
    if (!newWindow) {
      router.push({path: url.replace('#', '')})
    } else {
      store.dispatch('openLocation', url)
    }
  },
  openFormStg (strategy, itemId) {
    return forms.openFormStg(strategy, itemId)
  },
  openForm (itemId) {
    let strategy = this.createStrategy(null, 'INDIVIDUAL')
    return this.openFormStg(strategy, itemId)
  },
  getIndividual (id) {
    return new Promise((resolve, reject) => {
      store.dispatch('getPeopleIndividual', id).then(data => {
        resolve(data)
      })
    })
  },
  findPeopleByInn (inn) {
    return new Promise((resolve, reject) => {
      store.dispatch('findPeople', inn).then(data => resolve(data))
    })
  },
  findIndividualByInn (inn) {
    return new Promise((resolve, reject) => {
      this.findPeopleByInn(inn).then((peopleItems) => {
        if (peopleItems && peopleItems.content && peopleItems.content.length > 0) {
          store.dispatch('getPeopleIndividual', peopleItems.content[0].id).then((individual) => resolve(individual))
        } else {
          resolve(null)
        }
      })
    })
  },
  addHuman (companyRefCode, human) {
    return new Promise((resolve, reject) => {
      store.dispatch('updatePeopleIndividual', {
        individual: {lastName: human.lastName, firstName: human.firstName, middleName: human.middleName, innfl: human.inn},
        contact: companyRefCode ? {companyRefCode: companyRefCode, position: human.position} : null
      }).then(id => {
        resolve(id)
      })
    })
  },
  openByHuman (companyRefCode, human) {
    if (human && human.inn) {
      this.findPeopleByInn(human.inn).then(data => {
        if (data && data.content) {
          if (data.content.length > 0) {
            this.open(data.content[0].id)
          } else {
            this.addHuman(companyRefCode, human).then((id) => {
              this.open(id)
            })
          }
        }
      })
    }
  },
  getHolderPassports (companyRefCode) {
    return new Promise((resolve, reject) => {
      let result = []
      if (companyRefCode) {
        client.getHoldersByCompany(companyRefCode).then(hs => {
          console.log('getHolderPassports', hs)
          let innfls = hs.map(h => h.refObject && h.refObject.namespace === 'HUMAN' && h.refObject.inn ? h.refObject.inn.toString() : null)
          store.dispatch('getPeopleIndividualPassport', {innfls: innfls, companyRefCode: companyRefCode}).then(data => {
            let hMap = data.reduce((map, obj) => map.set(obj.individual.innfl, obj), new Map())
            hs.forEach(h => {
              let innfl = h.refObject && h.refObject.namespace === 'HUMAN' && h.refObject.inn ? h.refObject.inn.toString() : null
              let hItem = hMap.get(innfl)
              result.push({
                ref: h.ref,
                name: h.name,
                share: h.shares,
                innfl: innfl,
                personId: hItem && hItem.individual ? hItem.individual.id : null,
                individual: hItem && hItem.individual ? hItem.individual : null,
                passportId: hItem && hItem.doc ? hItem.doc.id : null,
                passport_rf: hItem && hItem.doc ? JSON.parse(hItem.doc.model) : null,
                contactId: hItem && hItem.contact ? hItem.contact.id : null,
                contact: hItem && hItem.contact ? hItem.contact : null,
                reason: ''
              })
            })
            resolve(result)
          })
        })
      } else {
        resolve(result)
      }
    })
  },
  openHolders (companyRefCode, holders) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-holder-list', vHolderList)
      const onInput = (data) => {
        resolve(data)
      }
      let title = 'Укажите паcпортные данные участников или представителей'
      let fullscreen = store.getters.getIsMobile
      let comp = { template: `
        <v-holder-list :fullscreen="fullscreen" :companyRefCode="companyRefCode" :holders="holders" :title="title" v-on:input="onSelect" v-on:close="$emit('close')"></v-holder-list>
      `,
        data () {
          return {
            onSelect: onInput,
            fullscreen: fullscreen,
            companyRefCode: companyRefCode,
            holders: holders,
            title: title
          }
        }
      }
      dialogs.modal(comp)
    })
  },
  getItemRef (itemId) {
    return store.getters.getRefToUrl(`PERSON:${itemId}`)
  },
  openContact (itemId, parentId) {
    return new Promise((resolve, reject) => {
      this.getIndividual(parentId).then(individual => {
        let strategy = this.createStrategy(null, 'CONTACT')
        strategy.setParentProps(individual)
        this.openFormStg(strategy, itemId).then(data => resolve(data))
      })
    })
  },
  openDoc (itemId, parentId, type) {
    return new Promise((resolve, reject) => {
      this.getIndividual(parentId).then(individual => {
        let strategy = this.createStrategy(null, type)
        strategy.setParentProps(individual)
        this.openFormStg(strategy, itemId).then(data => resolve(data))
      })
    })
  },
  selectDocByIndividual (cxt, individual, itemId, type) {
    return new Promise((resolve, reject) => {
      let items = []
      if (individual && individual.docs) {
        let docs = !type ? individual.docs
         : individual.docs.filter((doc) => formats.compareString(doc.type, type) === 0)
        docs.forEach(doc => {
          let strategy = this.createStrategy(cxt, doc.type)
          items.push({value: doc.id, text: `${strategy.viewTitle(strategy.createModelFromData(doc))}`})
        })
      }
      forms.selectItem(items, [], 'Выберите документ').then(data => resolve(data))
    })
  },
  selectContactByIndividual (cxt, individual, itemId, companyInn) {
    const _f = (v) => v || '-'
    return new Promise((resolve, reject) => {
      let items = []
      if (individual && individual.contacts) {
        let contacts = !companyInn ? individual.contacts
         : individual.contacts.filter((contact) => formats.compareString(companyInn, contact.companyInn === 0))
        contacts.forEach(contact => {
          items.push({value: contact.id, text: `${_f(contact.name)}: ${_f(contact.phone)}, ${_f(contact.email)}`})
        })
      }
      forms.selectItem(items, [], 'Выберите контакт').then(data => resolve(data))
    })
  },
  getContactsByCompany (refCode) {
    return refCode ? store.dispatch('getCompanyContacts', refCode) : []
  },
  sortContactsByCompany (items) {
    return items.sort((a, b) => formats.compareString(a.nameForCompany, b.nameForCompany))
  },
  selectContactByCompany (cxt, refCode) {
    const _f = (v) => v || '-'
    return new Promise((resolve, reject) => {
      let items = []
      this.getContactsByCompany(refCode)
      .then((data) => {
        let contacts = this.sortContactsByCompany(data)
        contacts.forEach(contact => {
          items.push({value: contact.id, text: `${_f(contact.nameForCompany)}: ${_f(contact.phone)}, ${_f(contact.email)}`})
        })
        forms.selectItem(items, [], 'Выберите контакт').then(data => resolve(data))
      })
    })
  },
  sortIndividualDoc (items) {
    let types = this.registeredTypeDoc()
    const comp = (a, b) => {
      return types.indexOf(a.type) > types.indexOf(b.type) ? 1 : (
      a.type === b.type ? (a && a.issued && a.issued > b.issued ? -1 : 1) : -1)
    }
    return items.sort(comp)
  },
  getIndividualDoc (cxt, id) {
    return new Promise((resolve, reject) => {
      store.dispatch('getPeopleIndividualDoc', id).then((doc) => {
        resolve(doc)
      })
    })
  },
  sortIndividualContact (items) {
    return items.sort((a, b) => formats.compareString(a.name, b.name))
  },
  getIndividualContact (id) {
    return new Promise((resolve, reject) => {
      store.dispatch('getPeopleIndividualContact', id).then((doc) => {
        resolve(doc)
      })
    })
  },
  selectIndividual (cxt, queryCxt, getQuery, favorite, radio) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-individual-selector', vIndividualSelector)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-individual-selector
        v-on:close="$emit('close')"
        v-on:input="onSelect"
        :queryCxt="queryCxt"
        :query="getQuery()"
        :fullscreen="fullscreen"
        :favorite="favorite"
        :radio="radio"
        ></v-individual-selector>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onSelect: (data) => resolve(data),
            queryCxt: queryCxt,
            getQuery: getQuery,
            favorite: favorite,
            radio: radio
          }
        }
      }
      dialogs.modal(comp)
    })
  },
  genders () {
    return [
      {value: 'F', text: 'Жен.'},
      {value: 'M', text: 'Муж.'}
    ]
  },
  citizenships () {
    return [
      {value: 'Российская Федерация'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/people/index.js